import { bool, oneOf, string } from 'prop-types'

import {
  AVAILABLE_PRODUCT_TEMPLATES,
  DEFAULT_PRESCRIPTION_TYPE,
  PRODUCT_TEMPLATES,
} from 'shared/consts/productTemplates'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import Collapsible from 'views/components/organisms/Collapsible'
import PrescriptionTypeBox from 'views/components/organisms/PrescriptionTypeBox'
import { getDefaultPrescriptionType } from 'views/components/pages/Product/helpers'
import { PRESCRIPTION_INFO_MODAL_ID } from 'views/consts'

import './PrescriptionTypes.scss'

const PrescriptionTypes = ({
  selectedPrescriptionType: prescriptionType,
  productTemplate,
  collapsible,
}) => {
  const selectedPrescriptionType =
    prescriptionType || getDefaultPrescriptionType(productTemplate)

  const selectBox = (
    <PrescriptionTypeBox
      productTemplate={productTemplate}
      selectedPrescriptionType={selectedPrescriptionType}
      label="Rezeptart"
      showLabel
      floatingLabel
    />
  )

  if (!collapsible) {
    return selectBox
  }

  return (
    <div
      className="o-PrescriptionTypes u-padding-large--top@medium u-margin-x-large--bottom@small-tiny"
      data-clientside-hook="prescriptionTypesCollapsible"
    >
      <Collapsible
        label="Rezept vorhanden?"
        id="prescription-type-collapsible"
        allScreensizes
        headerColor="background"
        forceDisplayWhenCollapsed
      >
        {selectBox}
        <ModalShowButton
          component={ButtonAsLink}
          className="u-no-wrap"
          name="prescription_info_2"
          modalId={PRESCRIPTION_INFO_MODAL_ID}
          data-clientside-hook="prescriptionTypesCollapsible__modal"
        >
          <span className="u-font-weight--bold u-display--block u-text-align--left u-padding--top">
            {/* TODO translations */}
            Wie funktioniert eine Rezeptbestellung?
          </span>
        </ModalShowButton>
      </Collapsible>
    </div>
  )
}

PrescriptionTypes.propTypes = {
  productTemplate: oneOf(AVAILABLE_PRODUCT_TEMPLATES),
  selectedPrescriptionType: string,
  collapsible: bool,
}

PrescriptionTypes.defaultProps = {
  productTemplate: PRODUCT_TEMPLATES.OTC,
  selectedPrescriptionType: DEFAULT_PRESCRIPTION_TYPE[PRODUCT_TEMPLATES.OTX],
  collapsible: false,
}

export default PrescriptionTypes
